import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { CreatorProgram as CreatorsProgramContent } from 'CreatorsProgram';

const AffiliateProgram = () => {
  return (
    <AppLayout>
      <CreatorsProgramContent />
    </AppLayout>
  );
};

export default AffiliateProgram;
